import styles from "./SectionBanner.module.css";
import servicesBannerImage from "../../assets/images/servicios/Group 42.png";

const SectionBanner = () => {
  return (
    <section>
      <div className={styles.bannerContainer}>
        <img
          src={servicesBannerImage}
          className={styles.bannerImage}
          alt="Servicios ADIAC"
          loading="lazy"
        />
        <div className={styles.bannerContent}>
          <div className={styles.title}>Nuestros Servicios</div>
          <div className={styles.textContainer}>
            <span className={styles.whiteText}>
              Medio nacional de <br />
            </span>
            <span className={styles.orangeText}>comunicación y promoción</span>
            <span className={styles.whiteText}>
              <br />
              de las empresas del <br />
            </span>
            <span className={styles.orangeText}>sector transporte</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionBanner;
